import React from 'react'
import { color } from '#components/svg/icons/ScrollBackward'

class ScrollForward extends React.Component {
  render() {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.325 8 4.8 12.525l.754.754L10.834 8 5.554 2.72l-.754.754z" fill={color(this.props)} fillRule="nonzero"/>
      </svg>
    )
  }
}

export default ScrollForward
